// @flow
import { useEffect, useState, useCallback } from "react";
import { css } from "styled-components";
import { media, useDebounce } from "@nested/brand";
import { BookIntroCall } from "./BookIntroCall";

const fixedContainer = css`
  padding: 10px 20px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 1;
  border-top: 1px solid ${({ theme }) => theme.palette.hague20};
  text-align: center;
  transition: transform 0.3s ease;
  transform: translateY(${({ showCta }) => (showCta ? 0 : "109px")});
  ${media.tablet`
    display: none;
  `}
`;

const buttonStyles = css`
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0;
`;

export const FloatingCta = () => {
  const [showCta, setShowCta] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [ctaTimer, setCtaTimer] = useState(null);
  const setTimer = useCallback(() => {
    setCtaTimer((timer) => {
      if (timer !== null) {
        clearTimeout(timer);
      }
      return setTimeout(() => {
        setShowCta(true);
      }, 300);
    });
  }, []);

  const debouncedSetTimer = useDebounce(setTimer, 300);

  useEffect(() => {
    const onScroll = () => {
      setShowCta(false);
      debouncedSetTimer();
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div css={fixedContainer} showCta={showCta}>
      <BookIntroCall css={buttonStyles} />
    </div>
  );
};
